var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"d-flex align-center justify-center"},[_c('v-card',{staticClass:"col-lg-7 col-md-7 col-sm-8 col-xl-5 pb-0 pt-0",staticStyle:{"border-radius":"15px"}},[(!_vm.success)?_c('sign-up-form',{on:{"onSuccess":_vm.onSuccess}}):_c('welcome')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }